import { gql } from '@apollo/client'

export const UPDATES_QUERY = gql`
query updatesQuery($ids:[String!]){
  playlistsAndResourcesQuery(ids:$ids){
    id:entityId
    entity_changed:entityChanged
    type:entityBundle
  }
}
`
;